<div class="admin-layout flex min-h-dvh flex-col bg-[#F9FAFB]">
  <header class="admin-header sticky top-0 z-10">
    <div class="flex h-16 items-center justify-between px-6">
      <div class="flex items-center gap-6">
        <a routerLink="/admin/dashboard" class="brand-link flex items-center gap-2">
          <div class="brand-pill">
            <span class="brand-eyebrow">corpers.ng</span>
            <span class="brand-sep">·</span>
            <span class="brand-label">Admin</span>
          </div>
        </a>

        <div class="brand-divider"></div>

        <nav class="hidden gap-1 sm:flex">
          <a
            mat-button
            routerLink="/admin/dashboard"
            routerLinkActive="nav-active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link"
          >Dashboard</a>
          <a
            mat-button
            routerLink="/admin/users"
            routerLinkActive="nav-active"
            class="nav-link"
          >Users</a>
          <a
            mat-button
            routerLink="/admin/posts"
            routerLinkActive="nav-active"
            class="nav-link"
          >Posts</a>
          <a
            mat-button
            routerLink="/admin/ppas"
            routerLinkActive="nav-active"
            class="nav-link"
          >PPAs</a>
          <a
            mat-button
            routerLink="/admin/chats"
            routerLinkActive="nav-active"
            class="nav-link"
          >Chats</a>
          <a
            mat-button
            routerLink="/admin/referrals"
            routerLinkActive="nav-active"
            class="nav-link"
          >Referrals</a>
        </nav>
      </div>

      <button mat-button class="logout-btn" (click)="logout()">
        <mat-icon class="logout-icon">logout</mat-icon>
        <span>Log out</span>
      </button>
    </div>
  </header>

  <main class="flex-1 p-6 lg:p-8">
    <router-outlet></router-outlet>
  </main>
</div>
